// extracted by mini-css-extract-plugin
export default {"myCustomDrawer":"SideDrawer_myCustomDrawer__Ov+44"};